export default __webpack_public_path__ + "static/media/react-logo.a544fd8c.png";